import { strapiCall } from "../../utils/api";
import * as types from "../types/market_type";

const fetchMarketInsights = () => async (dispatch) => {
  dispatch({ type: types.FETCHING_MARKET_INSIGHTS });

  const payload = {
    query: `
    {
      marketInsight {
        data {
          attributes {
            tagline {
              mainTitle
              subTitle
              countdown {
                enabled
                label
                title
                targetDateTime
              }
            }
            featuredReports {
                title
                subtitle
            }
            items{
              data {
                attributes {
                  heroSectionHeader
                  nameOfWhitePaper
                  slug
                  description
                  heroDescription
                  heroImageSrc {
                    data {
                      attributes {
                        url
                      }
                    }
                  }
                  cardImageSrc {
                    data {
                      attributes {
                        url
                      }
                    }
                  }
                  ctaLabel
                  asFeaturedIn{
                    enabled
                    title
                    items {
                      label
                      image {
                          data {
                              attributes {
                                url
                              }
                          }
                      }
                      href
                    }
                  }
                  leadForm {
                    title
                    description
                    submitLabel
                    redirectUrl
                  }
                  quote {
                    text
                    author
                  }
                  dataReveals {
                    title
                    subtitle
                    items {
                      value
                      description
                    }
                  }
                  reportHelpsYouDecide {
                    title
                    subtitle
                    items {
                      title
                      description
                      imageUrl {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                  whyReportMatters {
                    title
                    items {
                      emphasis
                      text
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
  };

  const response = await strapiCall(payload);

  if (response.status === 200) {
    const marketInsight =
      response.data?.data?.marketInsight?.data?.attributes || {};

    return dispatch({
      type: types.FETCH_MARKET_INSIGHTS_SUCCEEDED,
      payload: marketInsight,
    });
  } else {
    return dispatch({
      type: types.FETCH_MARKET_INSIGHTS_FAILED,
    });
  }
};

// Fetch single report by slug
const fetchMarketInsightBySlug = (slug) => async (dispatch) => {
  dispatch({ type: types.FETCH_MARKET_INSIGHT_BY_SLUG });

  try {
    const payload = {
      query: `
      query MarketInsightBySlug($slug: String!) {
        marketInsight {
          data {
            attributes {
              items(filters: { slug: { eq: $slug } }) {
                data {
                  attributes {
                    heroSectionHeader
                    nameOfWhitePaper
                    slug
                    description
                    heroDescription
                    heroImageSrc {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                    cardImageSrc {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                    ctaLabel
                    asFeaturedIn {
                      enabled
                      title
                      items {
                        label
                        image {
                          data {
                            attributes {
                              url
                            }
                          }
                        }
                        href
                      }
                    }
                    leadForm {
                      title
                      description
                      submitLabel
                      redirectUrl
                   }
                    quote {
                      text
                      author
                    }
                    dataReveals {
                      title
                      subtitle
                      items {
                        value
                        description
                      }
                    }
                    reportHelpsYouDecide {
                      title
                      subtitle
                      items {
                        title
                        description
                        imageUrl {
                          data {
                            attributes {
                              url
                            }
                          }
                        }
                      }
                    }
                    whyReportMatters {
                      title
                      items {
                        emphasis
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      `,
      variables: { slug },
    };

    // call your API function (replace fetchGraphQL with your implementation)
    const response = await strapiCall(payload);

    return dispatch({
      type: types.FETCH_MARKET_INSIGHT_BY_SLUG,
      payload:
        response.data?.data?.marketInsight?.data?.attributes?.items?.data[0],
    });
  } catch (error) {
    return dispatch({
      type: types.FETCH_MARKET_INSIGHT_BY_SLUG_ERROR,
      error,
    });
  }
};

export { fetchMarketInsightBySlug, fetchMarketInsights };
